import { AlertCircle } from "lucide-react";

export const ProblemSection = () => {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background to-secondary/20" />
      
      <div className="container relative z-10 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Left - The chaos illustration */}
            <div className="relative order-2 md:order-1">
              <div className="relative p-6 md:p-8 rounded-2xl bg-muted/50 border border-border/50">
                {/* Scattered items representing chaos */}
                <div className="space-y-4">
                  {/* Paper receipts */}
                  <div className="flex gap-3 items-start">
                    <div className="w-16 h-20 bg-card border border-border rounded shadow-sm rotate-[-3deg] flex-shrink-0">
                      <div className="p-2 space-y-1">
                        <div className="h-1.5 bg-muted-foreground/20 rounded w-full" />
                        <div className="h-1.5 bg-muted-foreground/20 rounded w-3/4" />
                        <div className="h-1.5 bg-muted-foreground/20 rounded w-1/2" />
                      </div>
                    </div>
                    <div className="w-14 h-16 bg-card border border-border rounded shadow-sm rotate-[5deg]">
                      <div className="p-2 space-y-1">
                        <div className="h-1 bg-muted-foreground/20 rounded w-full" />
                        <div className="h-1 bg-muted-foreground/20 rounded w-2/3" />
                      </div>
                    </div>
                    <div className="w-12 h-14 bg-card border border-border rounded shadow-sm rotate-[-2deg]">
                      <div className="p-1.5 space-y-1">
                        <div className="h-1 bg-muted-foreground/20 rounded w-full" />
                      </div>
                    </div>
                  </div>

                  {/* WhatsApp message bubbles */}
                  <div className="flex flex-col gap-2 pl-4">
                    <div className="self-start bg-success/10 text-success/80 text-xs px-3 py-1.5 rounded-lg rounded-tl-none max-w-[180px]">
                      "Bhaiya, today's sale was 12k"
                    </div>
                    <div className="self-end bg-success/10 text-success/80 text-xs px-3 py-1.5 rounded-lg rounded-tr-none max-w-[150px]">
                      "Expense kitna hua?"
                    </div>
                    <div className="self-start bg-success/10 text-success/80 text-xs px-3 py-1.5 rounded-lg rounded-tl-none max-w-[120px]">
                      "Yaad nahi..."
                    </div>
                  </div>

                  {/* Calculator and confusion */}
                  <div className="flex items-center gap-4 pt-2">
                    <div className="w-12 h-16 bg-card border border-border rounded-lg shadow-sm flex flex-col items-center justify-center">
                      <div className="text-[10px] font-mono text-muted-foreground">???</div>
                      <div className="grid grid-cols-3 gap-0.5 mt-1">
                        {[...Array(9)].map((_, i) => (
                          <div key={i} className="w-2 h-2 bg-muted-foreground/10 rounded-sm" />
                        ))}
                      </div>
                    </div>
                    <AlertCircle className="h-8 w-8 text-destructive/60 animate-pulse" />
                  </div>
                </div>
              </div>
            </div>

            {/* Right - The question */}
            <div className="order-1 md:order-2 text-center md:text-left space-y-6">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-destructive/10 border border-destructive/20">
                <span className="text-xs font-medium text-destructive">The Problem</span>
              </div>
              
              <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold leading-tight">
                <span className="text-accent">"Did I make money</span>
                <br />
                <span className="text-accent">today?"</span>
              </h2>
              
              <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
                The question that haunts <span className="text-foreground font-medium">47 million</span> Indian small business owners every night.
              </p>
              
              <p className="text-sm md:text-base text-muted-foreground">
                Paper receipts. WhatsApp messages. Memory. Hope.
                <br />
                <span className="text-foreground">Until the bank asks for records you don't have.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
